"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInput = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledInput = styled_components_1.default.input `
  border: none;
  font: ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  height: 60px;
  padding-left: 15px;
`;
